module.exports = __webpack_public_path__ + "static/media/icn_infection_covid_myway.0d4745ef.svg";